'use client';

import { c as _c } from "react/compiler-runtime";
import { useHmSpecialSale, isHmSpecialSaleProduct } from '@/app/_lib/hooks/useHmSpecialSale';

/**
 * Product-page line for the HM special (code) sale: the product is in a sale
 * with no price change, and the discount is applied by entering the code in
 * the cart. Renders nothing unless the `millerknoll_hm20_promotion_active`
 * preference is on, the product's supplier is in the MillerKnoll group, and
 * the product is flagged on_sale. State is fetched live (one request per
 * page, shared by every instance) so the preference flip takes effect
 * immediately despite static product pages.
 *
 * Rendered twice on the product page: under the trade-program line on mobile
 * only (above the fold on small screens) and above Add to Cart on all sizes.
 *
 * Copy is the owner's (2026-09-28).
 */
const HmSpecialSaleProductMessage = t0 => {
  const $ = _c(3);
  const {
    supplier_id,
    on_sale,
    className: t1
  } = t0;
  const className = t1 === undefined ? "mb-4 text-sm leading-tight text-right" : t1;
  const state = useHmSpecialSale(!!supplier_id && on_sale == 1);
  if (!isHmSpecialSaleProduct({
    supplier_id,
    on_sale
  }, state)) {
    return null;
  }
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-red">Save 20% With Code HM20</div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== className) {
    t3 = <div className={className}>{t2}</div>;
    $[1] = className;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
export default HmSpecialSaleProductMessage;